"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectArrayToMap = exports.priceTickerToMarketAsset = exports.isSymbolInverse = exports.mergeAssetStats = exports.createPositionId = exports.filterExchageInfoBySymbol = exports.getPositionSideForView = exports.createQuotePairPerpWrap = exports.createUsdPerpQuotePair = exports.createUsdtQuotePair = exports.createQuotePair = exports.COINM_BTC_SYMBOL = exports.KNOWN_FIAT = exports.KNOWN_STABLECOINS = exports.EAssets = void 0;
const shared_1 = require("../../types/binance/shared");
const constants_1 = require("../../config/constants");
var EAssets;
(function (EAssets) {
    EAssets["USDT"] = "USDT";
    EAssets["BUSD"] = "BUSD";
    EAssets["TUSD"] = "TUSD";
    EAssets["USDP"] = "USDP";
    EAssets["USDC"] = "USDC";
})(EAssets = exports.EAssets || (exports.EAssets = {}));
exports.KNOWN_STABLECOINS = [EAssets.USDT, EAssets.BUSD, EAssets.TUSD, EAssets.USDP, EAssets.USDC];
exports.KNOWN_FIAT = ['USD'];
const FIAT_MAP = {
    USD: EAssets.USDT
};
exports.COINM_BTC_SYMBOL = 'BTCUSD_PERP';
const createQuotePair = (params) => {
    const { assetIds, exchangeInfo, quoteId, quoteCustom } = params;
    return assetIds.reduce((acc, assetId) => {
        if (assetId === quoteId)
            return acc;
        const symbol = quoteCustom ? `${assetId}${quoteCustom}` : `${assetId}${quoteId}`;
        const inverseSymbol = quoteCustom ? `${quoteCustom}${assetId}` : `${quoteId}${assetId}`;
        const filteredBySymbol = (0, exports.filterExchageInfoBySymbol)({
            exchangeInfo,
            symbol: symbol
        });
        const filteredByInverseSymbol = (0, exports.filterExchageInfoBySymbol)({
            exchangeInfo,
            symbol: inverseSymbol
        });
        if (filteredBySymbol === undefined && filteredByInverseSymbol === undefined)
            return acc;
        return Object.assign(Object.assign({}, acc), { quotes: [
                ...acc.quotes,
                ...(filteredBySymbol ? [{
                        pair: filteredBySymbol.symbol,
                        baseAsset: assetId,
                        quoteAsset: quoteId
                        // quoteAsset: mapFiatToStable(quoteId)
                    }] : [])
            ], inverse: [
                ...acc.inverse,
                ...(filteredByInverseSymbol ? [{
                        pair: filteredByInverseSymbol.symbol,
                        baseAsset: quoteId,
                        quoteAsset: assetId
                        // quoteAsset: mapFiatToStable(quoteId)
                    }] : [])
            ] });
    }, {
        quotes: [],
        inverse: []
    });
};
exports.createQuotePair = createQuotePair;
const createUsdtQuotePair = (params) => {
    return (0, exports.createQuotePair)(Object.assign(Object.assign({}, params), { quoteId: EAssets.USDT }));
};
exports.createUsdtQuotePair = createUsdtQuotePair;
const createUsdPerpQuotePair = (params) => {
    return (0, exports.createQuotePair)(Object.assign(Object.assign({}, params), { quoteId: 'USD', quoteCustom: (0, exports.createQuotePairPerpWrap)('USD') }));
};
exports.createUsdPerpQuotePair = createUsdPerpQuotePair;
const createQuotePairPerpWrap = (asset) => {
    return `${asset}_PERP`;
};
exports.createQuotePairPerpWrap = createQuotePairPerpWrap;
const getPositionSideForView = (side, amount) => {
    return side !== shared_1.EPositionSide.BOTH ? side : Number(amount) >= 0 ? shared_1.EPositionSide.LONG : shared_1.EPositionSide.SHORT;
};
exports.getPositionSideForView = getPositionSideForView;
const filterExchageInfoBySymbol = (params) => {
    const { exchangeInfo } = params;
    const symbols = exchangeInfo.symbols; // workaround for union array type find error
    const symbolInfo = symbols.find(symbol => symbol.symbol === params.symbol);
    if (symbolInfo === undefined) {
        // console.warn(`unknown symbol ${params.symbol}`)
        return undefined;
    }
    return symbolInfo;
};
exports.filterExchageInfoBySymbol = filterExchageInfoBySymbol;
const createPositionId = (params) => {
    return `${params.symbol}-${params.side}`;
};
exports.createPositionId = createPositionId;
const mergeAssetStats = (assetStatsPrimary, assetStatsSecondary) => {
    var _a, _b;
    const assetsKnown = [...new Set([...(((_a = assetStatsPrimary.knownAssets) === null || _a === void 0 ? void 0 : _a.keys()) || []), ...(((_b = assetStatsSecondary.knownAssets) === null || _b === void 0 ? void 0 : _b.keys()) || [])])];
    const assetsToAdd = [...new Set([...assetStatsPrimary.assetsNew.keys(), ...assetStatsSecondary.assetsNew.keys()])];
    let assetsToRemove = [...new Set([...assetStatsPrimary.assetsNull.keys(), ...assetStatsSecondary.assetsNull.keys()])];
    assetsToRemove = assetsToRemove.filter(asset => {
        return !assetsToAdd.includes(asset) && !assetsKnown.includes(asset);
    });
    return {
        assetsNew: new Map(assetsToAdd.map(asset => {
            return [asset, asset];
        })),
        assetsNull: new Map(assetsToRemove.map(asset => {
            return [asset, asset];
        })),
    };
};
exports.mergeAssetStats = mergeAssetStats;
const isSymbolInverse = (symbol) => {
    return symbol.indexOf(EAssets.USDT) === 0;
};
exports.isSymbolInverse = isSymbolInverse;
const priceTickerToMarketAsset = (tickers, exchangeInfo) => {
    return tickers.reduce((acc, ticker) => {
        var _a, _b;
        const exchangeInfoForSymbol = (0, exports.filterExchageInfoBySymbol)({
            exchangeInfo,
            symbol: ticker.symbol
        });
        if (exchangeInfoForSymbol === undefined)
            return Object.assign({}, acc);
        const isInverse = (0, exports.isSymbolInverse)(ticker.symbol);
        return Object.assign(Object.assign(Object.assign({}, acc), { [exchangeInfoForSymbol.baseAsset]: {
                assetId: exchangeInfoForSymbol.baseAsset,
                quotes: Object.assign(Object.assign({}, (acc[exchangeInfoForSymbol.baseAsset] ? (_a = acc[exchangeInfoForSymbol.baseAsset]) === null || _a === void 0 ? void 0 : _a.quotes : {})), { [exchangeInfoForSymbol.quoteAsset]: Number(ticker.price) })
            } }), (isInverse ? {
            [exchangeInfoForSymbol.quoteAsset]: {
                assetId: exchangeInfoForSymbol.quoteAsset,
                quotes: Object.assign(Object.assign({}, (acc[exchangeInfoForSymbol.quoteAsset] ? (_b = acc[exchangeInfoForSymbol.quoteAsset]) === null || _b === void 0 ? void 0 : _b.quotes : {})), { [exchangeInfoForSymbol.baseAsset]: constants_1.BN_ONE.dividedBy(ticker.price).toNumber() })
            }
        } : {}));
    }, {});
};
exports.priceTickerToMarketAsset = priceTickerToMarketAsset;
const objectArrayToMap = (source, sourceKey) => {
    return new Map(source.map((sourceItem) => {
        return [sourceItem[sourceKey], sourceItem];
    }));
};
exports.objectArrayToMap = objectArrayToMap;
